const DetectorIcon = ({ strokeColor = "#808080" }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" fill="#4d4d4d" cx="397.55" cy="397.55" r="388.66"/>
        <circle 
          id="Grey" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="372.55"
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="343.4"
        />
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path 
            fill="#fcfcfc" 
            d="M324.07,431.45c-27.72,1.91-50.43-16.46-49.14-48.25.48-11.89.08-23.82.08-36.22-20.53-1-38.99-7.15-53.24-21.35-21.34-21.28-38.02-46.17-44.78-75.8-5.58-24.47,13.56-48.22,38.68-51.11,6.63-.76,13.34-1.27,20.01-1.28,109.87-.07,219.73-.06,329.6,0,14.49,0,28.2,2.39,39.32,13.09,12.79,12.31,17.67,28.17,12.33,43.82-9.94,29.1-24.12,56.41-49.12,76.18-11.8,9.33-25.09,15.15-40.43,15.47-2.28.05-4.55.64-7.53,1.09,0,13.3.01,26.34,0,39.38-.03,26.5-18.2,44.91-44.56,44.95-50.12.06-100.25.02-151.22.02M354.52,226.75c-43.12,0-86.25-.03-129.37.02-17.47.02-25.31,12.68-16.99,28.21,6.81,12.71,13.91,25.36,22.05,37.23,11.48,16.74,27.26,25.74,48.45,25.65,80.42-.37,160.84-.18,241.26-.11,16.84.02,31.02-6.17,40.67-19.67,9.53-13.34,17.86-27.64,25.74-42.05,9.57-17.52-2.62-29.74-18.52-29.58-70.51.71-141.02.3-213.29.3M491.39,381.08v-33.26h-186.74c0,12.58,0,24.75,0,36.93,0,13.6,4.75,18.42,18.14,18.42,49.22,0,98.45-.02,147.68-.02,16.58,0,20.43-3.75,20.93-22.06Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M508.76,537.09c-10.48-19.36-20.64-38.14-30.67-57.01-5.03-9.46-3.21-17.52,4.61-21.71,8.13-4.36,15.14-1.7,20.49,8.23,19.85,36.79,39.62,73.62,59.33,110.47,4.96,9.26,3.26,16.73-4.37,20.98-7.82,4.36-15.55,1.55-20.73-7.93-9.54-17.44-18.87-34.99-28.66-53.03h0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M234.04,572.57c19.52-35.74,38.6-70.97,57.76-106.15,5.49-10.07,12.32-12.8,20.3-8.46,7.39,4.02,9.57,12.72,4.55,22.05-20.11,37.32-40.44,74.53-60.85,111.69-4.2,7.64-11.09,9.57-18.4,5.97-7.25-3.57-9.91-11.26-6.55-19.15.79-1.86,1.85-3.61,3.19-5.94h0Z"
          />
          <path 
            fill="#fefefe" 
            d="M383.34,599.32c0-36.11-.02-71.36.02-106.6.01-10.39,4.98-15.88,14.09-15.8,8.92.08,13.9,5.69,13.91,15.99.04,39.04.05,78.07,0,117.1-.01,10.35-4.92,15.66-14.22,15.69-9.3.04-13.73-5.07-13.79-15.91-.02-3.2,0-6.41,0-10.48h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default DetectorIcon;